export default "__VITE_ASSET__71a824f9__"